var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreshproduce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 36,
    viewBox: "0 0 45 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.01771 1.38164C6.01771 1.38164 29.5565 6.30183 24.8369 17.7232C24.829 17.783 12.8871 26.3724 6.64229 5.17348C6.63229 5.22945 6.01771 1.38164 6.01771 1.38164Z",
    fill: "#f69516",
    stroke: "#6D4B40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6563 9.11362C43.6563 9.11362 38.4462 21.3954 30.8231 17.4537C30.782 17.4422 25.6811 9.88985 40.9604 9.00304C40.922 8.99091 43.6563 9.11362 43.6563 9.11362Z",
    fill: "#f69516",
    stroke: "#6D4B40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9745 33.2516C27.9745 33.2516 28.7812 19.1037 17.3381 9.64685",
    stroke: "#6D4B40",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.006 23.534C27.006 23.534 29.6507 16.1867 36.4891 12.7415",
    stroke: "#6D4B40",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreshproduce);
export default __webpack_public_path__ + "static/media/freshproduce.15b05d55b6040c553a806bb4af601457.svg";
export { ForwardRef as ReactComponent };